import { ReactElement } from "react";

import { CallToActionTypes } from "@utils/enums";

import { TApiDataStateSlice } from "@redux/store.types";

import { CartItemModel, CartModel } from "./@types/cart.model";

export const $CartModuleName = "cart";

export type TCartState = CartModel;

export type TCartDataSlice = TApiDataStateSlice<TCartState> &
    Record<string, any>;

export type CTAAction = (
    product: CartItemModel | null,
    action: CTAActions,
) => ReactElement<any>;

export type CTAVisual = (
    product: CartItemModel | null,
    action: CTAActions,
) => ReactElement<any>;

export type CTAActions = {
    type: CallToActionTypes;
    parameters: Array<any>;
    productParameters: Array<any>;
    isSilentAction?: boolean;
    action: CTAAction | null;
    visual?: CTAVisual;
    closable: boolean;
    isExtended?: boolean;
};

export type ProductCallToAction = {
    product: CartItemModel | null;
    actions: Array<CTAActions>;
};

export type BoxConditionModel = {
    name: string;
    enabled: boolean;
    checked: boolean;
    required: boolean;
};

export type AddToCartRequestBody = {
    deliveryType: string;
    quantity: number;
    shopId: string | null | undefined;
    sku: string;
    additionalServices?: string[];
};

export type AddToCartBulkRequestBody = {
    shopId: string | null;
    items: Array<{
        sku: string;
        quantity: number;
        deliveryType: string;
        additionalServices?: Array<string>;
    }>;
};

export enum CartItemConfigUpdateOrigin {
    PRODUCT_PAGE = "fromProductPage",
    CART_PAGE = "fromCartPage",
}

export enum CheckoutStepValidationResult {
    RedirectToCart = "redirect-to-cart",
    RedirectToStep = "redirect-to-step",
    Valid = "valid",
}
